import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import type { FunctionComponent } from 'react';

import { TOOLTIP_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { ContextualHelp } from 'src/app/v1/views/shared/ContextualHelp';

import translations from './.vocab';

export const PricePanelHelpText: FunctionComponent = () => {
  const { t } = useTranslations(translations);

  return (
    <ContextualHelp
      ariaLabel="Price Panel Help"
      tooltipId="price-panel-help-tooltip"
      message={<Text>{t('price-panel-help-text')}</Text>}
      onTrigger={() =>
        getTrackingAdapter.sendLinkEvent({
          eventName: TOOLTIP_PRESSED,
          tooltipType: 'price panel',
        })
      }
    />
  );
};
